"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _react = _interopRequireWildcard(require("react"));

var _input = _interopRequireDefault(require("../../input"));

var _context = require("../context");

var _utils = require("../utils");

var _actions = require("../actions");

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SelectAllCheckbox = function SelectAllCheckbox() {
  var _useTable = (0, _context.useTable)(),
      selectedRows = _useTable.selectedRows,
      disabledRows = _useTable.disabledRows,
      uniqueDataKey = _useTable.uniqueDataKey,
      data = _useTable.data,
      fireAction = _useTable.fireAction,
      controlSelection = _useTable.controlSelection,
      onSelectAll = _useTable.onSelectAll,
      paginationEnabled = _useTable.paginationEnabled;

  var totalEnabledSelected = (0, _filter["default"])(selectedRows).call(selectedRows, function (r) {
    return !(0, _includes["default"])(disabledRows).call(disabledRows, r);
  }).length;
  var totalEnabledRows = (0, _filter["default"])(data).call(data, function (row) {
    return !(0, _includes["default"])(disabledRows).call(disabledRows, row[uniqueDataKey]);
  }).length;
  var isChecked = totalEnabledSelected >= totalEnabledRows && totalEnabledRows > 0;
  var indeterminate = totalEnabledSelected > 0 && totalEnabledSelected !== totalEnabledRows;
  var checkbox = (0, _react.useRef)(null);

  if (paginationEnabled && !controlSelection) {
    var allRowIds = data ? (0, _map["default"])(data).call(data, function (obj) {
      return obj[uniqueDataKey];
    }) : [];
    var currentRows = (0, _filter["default"])(selectedRows).call(selectedRows, function (rowId) {
      return (0, _includes["default"])(allRowIds).call(allRowIds, rowId);
    });
    /* When a selectedrow is deleted or data is changed: in both cases we need to reset checkbox */

    if (currentRows.length === 0) {
      isChecked = false;
      indeterminate = false;
    }
  }

  (0, _react.useEffect)(function () {
    if (checkbox.current) {
      checkbox.current.indeterminate = indeterminate;
    }

    if (indeterminate) {
      fireAction((0, _actions.allRowsSelected)(false));
    }
  }, [checkbox, indeterminate, selectedRows, fireAction]);
  return /*#__PURE__*/_react["default"].createElement(_input["default"], {
    innerRef: checkbox,
    type: "checkbox",
    checked: isChecked,
    className: "row-selection-input orion-data-grid--select-all",
    onChange: function onChange(e) {
      /* istanbul ignore if */
      // will open this when come to test actions
      if (!controlSelection) {
        fireAction((0, _actions.toggleSelectAll)(indeterminate ? false : e.target.checked));
      }
      /* istanbul ignore else */


      if ((0, _utils.isFunction)(onSelectAll)) {
        onSelectAll(e.target.checked);
      }
    }
  });
};

var _default = SelectAllCheckbox;
exports["default"] = _default;